import PaymentsTab from 'routes/LeadList/components/PaymentsTab/PaymentsTab';

export default PaymentsTab;
